import { TypographyColor } from 'melp-design/components';
import { AdminBrandStatus } from './admin-brands.types';

export const COLOR_BY_STATUS: Record<AdminBrandStatus, TypographyColor> = {
  enabled: 'success',
  disabled: 'textSecondary',
  duplicate: 'error',
};
